import React from "react";
import cx from "classnames";
import "./Container.css";

const Container = ({ grey, children, ...props }) => (
  <div
    className={cx("Container", { "Container--Grey": grey })}
    {...props}
  >
  <div className="Container__Content" children={children}/>
  </div>
);

export default Container;
